export default "__VITE_ASSET__G16bzUbB__"